<ng-template #modalCancelBtn let-modal>
    <div class="modal-header border-bottom-0 p-0 bot_spa_aft_sect_heading">
        <ng-container *ngIf="flowType?.type == 'P'">
            <span class="sectionHeading_one">{{'popupMessages.cancelMsg' | translate}}</span>
        </ng-container>
        <ng-container *ngIf="flowType?.type == 'S'">
            <span class="sectionHeading_one">{{'popupMessages.cancelMsg_switch' | translate}}</span>
        </ng-container> <button type="button" id="clsTooltipa" (click)="modal.close()" aria-label="Close"
            class="infoButton" data-toggle="tooltip">
            <span class="sectionHeading_one" aria-hidden="true">&times;</span>
            <span class="show-for-sr">{{'persInfo.close' | translate}}</span>
        </button>
    </div>
    <div class="modal-body p-0">
        <div class="row no-gutters">
            <div class="col-md-6 col-12 pr-md-2 order-md-1 order-2">
                <button type="button" *ngIf="!issessionExpired" class="common_btn cancelBtn_features popUpCancel w-100"
                    (click)="cancelModal();modal.close()">{{'popupMessages.userCancelNoBtn' |
                    translate}} </button>
            </div>
            <div class="col-md-6 col-12 pl-md-2 order-md-2 order-1 bot_spa_aft_mobile_sec_heading">
                <button type="button" *ngIf="!issessionExpired" class="common_btn saveNextBtn_features w-100"
                    (click)="dismissModal()">{{'popupMessages.userCancelYesBtn' | translate}}</button>
            </div>
        </div>
    </div>
</ng-template>
<button type="button" tabindex="0" *ngIf="!isIos" (click)="openWindowCustomClass(modalCancelBtn)" id="uniqCncBtn"
    class="common_btn cancelBtn_features popUpCancel">{{
    'buttonallpages.cancel' | translate }}</button>
<button type="button" tabindex="0" *ngIf="isIos" (click)="openDialog()" id="uniqCncBtn"
    class="common_btn cancelBtn_features popUpCancel">{{
    'buttonallpages.cancel' | translate }}</button>